import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../utils/config';

const GstCategoryList = () => {
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState({
    name: '',
    gst_percent: ''
  });
  const [editingId, setEditingId] = useState(null);
  const token = localStorage.getItem('token');

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/gst-categories`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCategories(res.data);
    } catch (err) {
      console.error('Error fetching GST categories:', err);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      name: form.name.trim(),
      gst_percent: form.gst_percent === '' ? null : parseFloat(form.gst_percent)
    };

    if (!payload.name || payload.gst_percent === null || isNaN(payload.gst_percent)) {
      alert('Please enter valid name and GST percentage');
      return;
    }

    try {
      if (editingId) {
        await axios.put(
          `${API_BASE_URL}/api/gst-categories/${editingId}`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        await axios.post(`${API_BASE_URL}/api/gst-categories`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }

      setForm({ name: '', gst_percent: '' });
      setEditingId(null);
      fetchCategories();
    } catch (err) {
      console.error('Error saving GST category:', err);
      alert('Error saving GST category');
    }
  };

  const handleEdit = (cat) => {
    setForm({ name: cat.name, gst_percent: cat.gst_percent });
    setEditingId(cat.id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure to delete this GST category?')) return;

    try {
      await axios.delete(`${API_BASE_URL}/api/gst-categories/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchCategories();
    } catch (err) {
      console.error('Error deleting GST category:', err);
      alert('Failed to delete GST category');
    }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto bg-white shadow rounded">
      <h2 className="text-xl font-bold mb-4">GST Categories</h2>

      {/* GST Form */}
      <form onSubmit={handleSubmit} className="space-y-4 mb-6">
        <div>
          <label className="block text-sm font-medium">Category Name</label>
          <input
            type="text"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="w-full border px-3 py-2 rounded"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium">GST %</label>
          <input
            type="number"
            value={form.gst_percent}
            onChange={(e) => {
              const value = e.target.value;
              setForm({
                ...form,
                gst_percent: value === '' ? '' : parseFloat(value)
              });
            }}
            className="w-full border px-3 py-2 rounded"
            min="0"
            step="0.01"
            required
          />
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          {editingId ? 'Update Category' : 'Add Category'}
        </button>
      </form>

      {/* GST Categories Table */}
      <table className="min-w-full text-sm border">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 border">Name</th>
            <th className="px-4 py-2 border">GST %</th>
            <th className="px-4 py-2 border">Actions</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((cat) => (
            <tr key={cat.id}>
              <td className="px-4 py-2 border">{cat.name}</td>
              <td className="px-4 py-2 border">{cat.gst_percent}</td>
              <td className="px-4 py-2 border">
                <button
                  onClick={() => handleEdit(cat)}
                  className="mr-2 text-blue-600 hover:underline"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(cat.id)}
                  className="text-red-600 hover:underline"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}

          {categories.length === 0 && (
            <tr>
              <td colSpan="3" className="px-4 py-6 text-center text-gray-500">
                No GST categories found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default GstCategoryList;
